module.exports = __webpack_public_path__ + "static/media/flag-anthem.3a5b0932.png";